
<template>
  <div>
    <v-checkbox class="ml-2" v-model="is_without_payment" label="Selecionar métodos pagamento depois"></v-checkbox>
    <template v-if="!is_without_payment">
      <EditOrderPayments ref="form" :order="order" wholesale></EditOrderPayments>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SelectWholesaleOrderPayments',
  mixins: [],
  props: {
    order: {
      type: [Object],
    },
    stepper_count: {
      type: [Number, String]
    }
  },
  components: {
    EditOrderPayments: () => import("@/components/create_order/shared/payments/EditOrderPayments.vue"),
  },
  data() {
    return {
      is_without_payment: false,
    }
  },
  methods:{
    validate(){
      if(this.is_without_payment){
        return true
      }else{
        return this.$refs.form.validate()
      }
    },
    checkStepper(){
      if(this.stepper_count == 6 || this.stepper_count == '6'){
        this.setPaymentsPercentage()
      }
    },
    setPaymentsPercentage(){
      if(this.order.client_id){
        let total_sell_price = this.order.items_attributes.reduce((acc, el) => (Number(el.bag_sell_price) * Number(el.total_bags)) + acc, 0 )
        
        let mapped_payments = this.order.payments.list.map(el => {
          let {ammount, ...rest} = el
          return {
            ammount: (total_sell_price * el.percentage / 100).toFixed(2),
            ...rest,
          }
        })
        this.order.payments.list = []
        this.order.payments.list = mapped_payments
        
        let total_payment = this.order.payments.list.reduce((acc, el) => Number(el.ammount) + acc, 0 )
        
        if( total_payment != total_sell_price){
          this.order.payments.list[this.order.payments.list.length - 1].ammount = (Number(this.order.payments.list[this.order.payments.list.length -1].ammount) - (Number(total_payment) - Number(total_sell_price))).toFixed(2);
        }
      }
    },
  },
  watch:{
    stepper_count(){
      this.checkStepper()
    },
    is_without_payment(nv){
      if(nv){
        this.order.payments = {
          list:[],
          has_cash: false,
          has_deposit: false,
        }
      }
    },
  }
}
</script>